import React, { useState, useEffect, useMemo } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { MdOutlineFileUpload } from "react-icons/md";
import redirectURL from "../redirectURL"
import { utils, writeFile } from "xlsx";
import * as XLSX from "xlsx";
import { RiDeleteBin5Line } from "react-icons/ri";
import { IoMdAdd } from "react-icons/io";
import { FaInfoCircle } from "react-icons/fa";
import "../../assets/css/inventorymanagement.css"

const BatchMaster = () => {
  const [loadshow, setLoadshow] = useState("show-n");
  const [overlayBlock, setOverlayBlock] = useState("show-n");
  const [overlyBlock, setOverlyBlock] = useState("show-n");
  const [show, setShow] = useState(false);
  const [basicTitle, setBasicTitle] = useState("");
  const [basicType, setBasicType] = useState("default");
  const [rowData, setRowData] = useState([]);
  const [isSliderOpen, setSliderOpen] = useState(false);
  const [sliderType, setSliderType] = useState(null);
  const [sliderCl, setSliderCl] = useState("");
  const [sliderTitle, setSliderTitle] = useState("");
  const [uploadedFileData, setUploadedFileData] = useState([]);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [file, setFile] = useState(null)
  const [isLoadTrue, setIsLoadTrue] = useState(true)
  const [showTooltip, setShowTooltip] = useState(false)
  
  // Date filter states and helpers
  const pad2 = (n) => String(n).padStart(2, "0");
  const todayYMD = () => {
    const d = new Date();
    return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
  };
  const [uploadedDate, setUploadedDate] = useState(todayYMD());
  const [editFormData, setEditFormData] = useState({
    plant_id: "",
    plant_name: "",
    location: "",
    region: "",
    remarks: "",
  });
  const [duplicatedEditData, setDuplicatedEditData] = useState({
     plant_id: "",
    plant_name: "",
    location: "",
    region: "",
    remarks: ""
  });
  
  const columnWithDefs = [
    { headerName: "Date of Entry", field: "date_of_entry", tooltipField: "date_of_entry", sortable: true, resizable: true },
    { headerName: "Location", field: "location", tooltipField: "location", sortable: true, resizable: true },
    { headerName: "POC", field: "poc", tooltipField: "poc", sortable: true, resizable: true },
    { headerName: "SKU Code", field: "sku_code", tooltipField: "sku_code", sortable: true, resizable: true },
    { headerName: "SKU Description", field: "sku_description", tooltipField: "sku_description", sortable: true, resizable: true },
    { headerName: "Category", field: "category", tooltipField: "category", sortable: true, resizable: true },
    { headerName: "Batch No.", field: "batch_no", tooltipField: "batch_no", sortable: true, resizable: true },
    { headerName: "Manufacturing Date", field: "manufacturing_date", tooltipField: "manufacturing_date", sortable: true, resizable: true },
    { headerName: "Expiry Date", field: "expiry_date", tooltipField: "expiry_date", sortable: true, resizable: true },
    { headerName: "Product Life Check", field: "product_life_check", tooltipField: "product_life_check", sortable: true, resizable: true },
    { headerName: "Approved/Sent Qty", field: "approved_sent_qty", tooltipField: "approved_sent_qty", sortable: true, resizable: true },
    { headerName: "Qty Handover to QC", field: "qty_handover_to_qc", tooltipField: "qty_handover_to_qc", sortable: true, resizable: true },
    { headerName: "Qty Received by Ops", field: "qty_received_by_ops", tooltipField: "qty_received_by_ops", sortable: true, resizable: true },
    { headerName: "Diff", field: "diff", tooltipField: "diff", sortable: true, resizable: true },
    { headerName: "Bhiwandi", field: "bhiwandi", tooltipField: "bhiwandi", sortable: true, resizable: true },
    { headerName: "Bangalore", field: "bangalore", tooltipField: "bangalore", sortable: true, resizable: true },
    { headerName: "Gurgaon", field: "gurgaon", tooltipField: "gurgaon", sortable: true, resizable: true },
    { headerName: "Check", field: "check", tooltipField: "check", sortable: true, resizable: true },
    { headerName: "Uploaded Date", field: "uploaded_date", tooltipField: "uploaded_date", sortable: true, resizable: true },
  ];
  
  

  const resetFormData = () => {
    setEditFormData({ 
     plant_id: "",
      plant_name: "",
      location: "",
      region: "",
      remarks: "",
    });
    setDuplicatedEditData({
      plant_id: "",
      plant_name: "",
      location: "",
      region: "",
      remarks: "",
    });
  };
  
  const hideOverlySlideBlock = () => {
    setOverlyBlock("show-n");
    setLoadshow("show-n");
    setSliderOpen(false);
    if (document.getElementById("bulkUploadFile")) {
      document.getElementById("bulkUploadFile").value = "";
    }
    resetFormData()
    setUploadedFileData([]);
  };

  const onClickAddNewProduct = () => {
    resetFormData();
    setSliderOpen(true);
    setSliderType(1)
    setSliderCl("slider-25");
    setSliderTitle("Add New Plant");
    setOverlyBlock("show-m");
  };

    const handleEdit = (row) => {
    setSliderOpen(true);
    setSliderType(3); 
    setSliderCl("slider-25");
    setSliderTitle(`Edit Product - ${row.plant_id}`);
    setOverlyBlock("show-m");
    setEditFormData({
      plant_id: row.plant_id || "",
      plant_name: row.plant_name || "",
      location: row.location || "",
      region: row.region || "",
      remarks: row.remarks || "",
    });

    setDuplicatedEditData({
      plant_id: row.plant_id || "",
      plant_name: row.plant_name || "",
      location: row.location || "",
      region: row.region || "",
      remarks: row.remarks || "",
    });
  };

  const handleDelete = (row) => {
    setSelectedRow(row);
    setShowDeletePopup(true);
    setOverlayBlock("show-m");
   
  };

  const sideBar = useMemo(() => ({
    toolPanels: [
      {
        id: "columns",
        labelDefault: "Columns",
        labelKey: "columns",
        iconKey: "columns",
        toolPanel: "agColumnsToolPanel",
      },
      {
        id: "filters",
        labelDefault: "Filters",
        labelKey: "filters",
        iconKey: "filter",
        toolPanel: "agFiltersToolPanel",
      },
    ]
  }), []);

  const statusPanel = {
      statusPanels: [
          {
              statusPanel: "agTotalAndFilteredRowCountComponent",
              align: "left"
          },
          {
              statusPanel: "agTotalRowCountComponent",
              align: "center"
          },
          { statusPanel: "agFilteredRowCountComponent" },
          { statusPanel: "agSelectedRowCountComponent" },
          { statusPanel: "agAggregationComponent" }
      ]
  }
  const defaultColDef = {
    sortable: true,
    filter: true,
    pivot: true,
    enableValue: true,
    enableRowGroup: true,
    resizable: true,
  }

  const getSkuMasterData = async (dateStr = null) => {
    try{
      const payload = { uploaded_date: dateStr || uploadedDate };
      const response = await redirectURL.post("masters/getBatchMasterData", payload)
      if (response.status === 200) {
        if (response.data.data && response.data.data.length > 0) {
          setRowData(response.data.data);
          setLoadshow("show-n");
          setOverlayBlock("show-n");
        } else {
          setBasicTitle("No Batch master data found");
          setBasicType("info");
          setShow(true);
          setRowData([])
        }
      }
    }
    catch (error) {
      console.error("Error fetching Batch master data:", error);
      setBasicTitle("Failed to fetch Batch master data");
      setBasicType("error");
      setShow(true);
    }
  }

  const fetchData = async (dateStr) => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    await getSkuMasterData(dateStr);
    setLoadshow("show-n");
    setOverlayBlock("show-n");
  }

  useEffect(() => {
    fetchData(uploadedDate);
  }, []);

const closeAlert = () => {
  const fileInput = document.getElementById("bulkUploadFile");
   if (fileInput !== null) {  // Check if the element exists
    fileInput.value = "";  // Clears the input if element exists
  }
  setUploadedFileData([]);
  setFile(null)
  setShow(false);
  setLoadshow("show-n");
  setOverlayBlock("show-n");
  setOverlyBlock("show-n");
  setSliderOpen(false);
  setShowDeletePopup(false) 
//   if (isLoadTrue) {
    // window.location.reload()
//   }
};

const onClickingSliderCloseIcon = () => {
    setOverlyBlock("show-n");
    setSliderOpen(false);
    if (document.getElementById("bulkUploadFile")) {
      document.getElementById("bulkUploadFile").value = "";
    }
    resetFormData();
    setUploadedFileData([]);
  };

const downloadExcelTemplate = () => {
    const sampleData = [
      [
        "Plant Id",
        "Plant Name",
        "Location",
        "Region",
        "Remarks"
      ]
    ];

    const ws = utils.aoa_to_sheet(sampleData);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Sheet1");

    writeFile(wb, "sample_plant_template.xlsx");
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFile(e.target.value)
    const reader = new FileReader();
    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const parsedData = XLSX.utils.sheet_to_json(worksheet, {
        raw: false,
        dateNF: "yyyy-mm-dd",
      });
      const mapping = {
        "Plant Id": "plant_id",
        "Plant Name": "plant_name",
        "Location": "location",
        "Region": "region",
        "Remarks" : "remarks"
      };

      function toSnakeCase(str) {
          return str
            .trim()
            .replace(/\s+/g, '_')           // replace spaces with underscores
            .replace(/[A-Z]/g, letter => letter.toLowerCase()) // lowercase any capitals
            .replace(/[^a-z0-9_]/g, '')     // remove any special chars if needed
        }

      const result = parsedData.map(item => {
        const newItem = {};
        for (const key in item) {
          if (mapping[key]) {
            newItem[mapping[key]] = item[key];
          } else {
            newItem[toSnakeCase(key)] = item[key];
          }
        }
        return newItem;
      });

      console.log("Parsed Data:", result);
      setUploadedFileData(result);
    };
    reader.readAsArrayBuffer(file);
  };
  
  const onClickingFileSubmit = async () => {
    if(uploadedFileData.length === 0){
      setShow(true)
      setBasicType("info")
      setBasicTitle("Please upload a file")
      return 
    }
    const params = { masterData: uploadedFileData };
      try {
        const response = await redirectURL.post(
          "masters/storeMasterPlantData",
          params
        );
        if (response.data.status === "success") {
          setUploadedFileData([])
          await fetchData(uploadedDate);
          setLoadshow("show-n");
          setOverlayBlock("show-n");
          setShow(true);
          setBasicType("success");
          setBasicTitle("Data Uploaded Successfully");
          // User Action Triggering Starts Here
          var userData = {
            email: localStorage.getItem("email"),
            user_code: localStorage.getItem("user_code"),
            action: "Bulk Uploaded New Plant",
            status: "Success",
            path: window.location.pathname
          }
          triggerUserAction(userData)
          // User Action Triggering Ends Here
        } else {
          setLoadshow("show-n");
          setOverlayBlock("show-n");
          setShow(true);
          setBasicType("info");
          setBasicTitle("Data Upload Failed");
          setIsLoadTrue(true)
          // User Action Triggering Starts Here
          var userData = {
            email: localStorage.getItem("email"),
            user_code: localStorage.getItem("user_code"),
            action: "Bulk Uploaded New Plant",
            status: "Failure",
            path: window.location.pathname
          }
          triggerUserAction(userData)
          // User Action Triggering Ends Here
        }
      } catch (error) {
        const errorMessage = error.response?.data?.message || "An error occurred";
        setUploadedFileData([])
        setShow(true);
        setBasicType("info");
        setBasicTitle(errorMessage);
        // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Bulk Uploaded New Plant",
          status: "Failure",
          path: window.location.pathname
        }
        triggerUserAction(userData)
        // User Action Triggering Ends Here
      }
  };

  const onClickUploadSkuMasterData = (event) => {
    setUploadedFileData([])
    setSliderOpen(true);
    setSliderType(2);
    setSliderCl("slider-25");
    setSliderTitle("Upload Plant Master Data");
    setOverlyBlock("show-m");
  };

  const onClickingUpdateSkuData = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");  
    const params = {  
      plant_id: editFormData.plant_id,
      plant_name: editFormData.plant_name,
      location: editFormData.location,
      region: editFormData.region,
      remarks: editFormData.remarks,
    };

    const isNeedtoUpdate = Object.keys(duplicatedEditData).some(
      (key) => duplicatedEditData[key] !== editFormData[key]
    );

    if (!isNeedtoUpdate) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("No changes made to Plant data");
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      return;
    }

    try {
      const response = await redirectURL.post(
        "masters/updateMasterPlant",
        params
      );

      if (response.data.status === "success") {
        await fetchData(uploadedDate);
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("success");
        setBasicTitle("Plant Data Updated Successfully");

        const updatedRowData = rowData.map((row) =>
          row.plant_id === editFormData.plant_id ? editFormData : row
        );

        setRowData(updatedRowData);
        // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Edited Plant",
          status: "Success",
          path: window.location.pathname
        }
        triggerUserAction(userData)
        // User Action Triggering Ends Here
      } else {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("info");
        setBasicTitle("Failed to update Plant data");
        // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Edited Plant",
          status: "Failure",
          path: window.location.pathname
        }
        triggerUserAction(userData)
        // User Action Triggering Ends Here
      }
      
    } catch (error) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Failed to update Plant data");
      // User Action Triggering Starts Here
      var userData = {
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "Edited Plant",
        status: "Failure",
        path: window.location.pathname
      }
      triggerUserAction(userData)
      // User Action Triggering Ends Here
    }
  }

  const handleAddSkuProduct = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    const params = {
      plant_id: editFormData.plant_id,
      plant_name: editFormData.plant_name,
      location: editFormData.location,
      region: editFormData.region,
      remarks: editFormData.remarks
    };
    const validationErrors = Object.keys(params).filter(
      (key) => !params[key] || params[key].trim() === ""
    );

    if (validationErrors.length > 0) {
      setShow(true);
      setBasicType("info");
      setBasicTitle(`Please fill in all required fields: ${validationErrors.join(", ")}`);
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      return;
    }
    const validSkuCode = /^[a-zA-Z0-9_-]+$/.test(params.plant_id);  
    if (!validSkuCode) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Plant Id can only contain letters, numbers, underscores, and hyphens");
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      return;
    }
    try {
      const response = await redirectURL.post(
        "masters/addNewPlant",
        params
      );
   
      if (response.status === 200 && response.data.status === "success") {
        await fetchData(uploadedDate);
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("success");
        setBasicTitle("New Plant Added Successfully");
        setRowData((prevRowData) => [...prevRowData, params]);
        // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Added New Plant",
          status: "Success",
          path: window.location.pathname
        }
        triggerUserAction(userData)
        // User Action Triggering Ends Here

      } else {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("info");
        setBasicTitle("Failed to add New Plant");
        // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Added New Plant",
          status: "Failure",
          path: window.location.pathname
        }
        triggerUserAction(userData)
        // User Action Triggering Ends Here
      }
     
    } catch (error) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Failed to add New Plant");
      // User Action Triggering Starts Here
      var userData = {
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "Added New Plant",
        status: "Failure",
        path: window.location.pathname
      }
      triggerUserAction(userData)
      // User Action Triggering Ends Here
    }
  }

  // Function To Trigger User Action
  const triggerUserAction = (trigerdata) => {
    redirectURL.post('inventory/triggerUserAction', trigerdata)
  }

  const onClickingPopupDeleteBtn = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    const params = { plant_id: selectedRow.plant_id };
    try { 
      const response = await redirectURL.post(
        "masters/deletePlant",
        params
      );
    
      if (response.data.status === "success") {
        await fetchData(uploadedDate)
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShowDeletePopup(false);
        setShow(true);
        setBasicType("success");
        setBasicTitle("Plant Deleted Successfully");
        // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Deleted Plant",
          status: "Success",
          path: window.location.pathname
        }
        triggerUserAction(userData)
        // User Action Triggering Ends Here
      } else {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("info");
        setBasicTitle("Failed to delete Plant");
        // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Deleted Plant",
          status: "Failure",
          path: window.location.pathname
        }
        triggerUserAction(userData)
        // User Action Triggering Ends Here
      }
    } catch (error) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Failed to delete Plant");
      // User Action Triggering Starts Here
      var userData = {
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "Delete Plant",
        status: "Failure",
        path: window.location.pathname
      }
      triggerUserAction(userData)
      // User Action Triggering Ends Here
    }
  };

  const onClickDeletePopupCancelBtn = () => {
      setOverlayBlock("show-n");
      setShowDeletePopup(false);
  };

  return (
    <>
      <div className="container-fluid mt-3">
        <div style={{ zIndex: "9999999" }}>
              <SweetAlert
                  show={show}
                  type={basicType}
                  title={basicTitle}
                  onConfirm={closeAlert}
                  style={{ fontSize: "9px" }}
              >
              </SweetAlert>
          </div>

        <div className="row" style={{fontSize: "1rem", fontWeight: "bold", fontFamily: "Arial, sans-serif"}}>
          <div className="col-sm-12">
            <h1 className="col-sm-12" style={{color : "#B9366D", fontSize : "18px", fontWeight : "bold", fontFamily : "sans-serif"}}>Batch Master</h1>
          </div>
          
          {/* Date Filter Section */}
          <div className="col-sm-8 row pl-1 mt-2 mb-2" style={{ display: "flex", alignItems: "center" }}>
            <div className="col-4">
              <label htmlFor="uploadedDate" style={{ fontSize: "13px", fontWeight: 400 }}>Uploaded Date:</label>
              <input
                type="date"
                id="uploadedDate"
                value={uploadedDate}
                onChange={(e) => setUploadedDate(e.target.value)}
                onClick={() => document.getElementById("uploadedDate").showPicker?.()}
                style={{
                  padding: "7px",
                  borderRadius: "5px",
                  border: "1px solid #d9d9d9",
                  width: "100%",
                  marginBottom: "0px",
                  cursor: "pointer",
                }}
                max={todayYMD()}
              />
            </div>

            <div className="col-6 mt-4">
              <button 
                type="button" 
                onClick={(e) => { 
                  e.preventDefault(); 
                  fetchData(uploadedDate); 
                }} 
                style={{
                  backgroundColor: "#93385D",
                  color: "#fff",
                  borderRadius: "5px",
                  padding: "8px 20px",
                  border: "none",
                  cursor: "pointer",
                  marginRight: "20px",
                  marginTop: "5px"
                }}
              >
                Apply
              </button>

              <button
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  const d = todayYMD();
                  setUploadedDate(d);
                  fetchData(d);
                }}
                style={{
                  backgroundColor: "#fff",
                  color: "#000",
                  borderRadius: "5px",
                  padding: "8px 20px",
                  border: "1px solid #d9d9d9",
                  cursor: "pointer",
                }}
              >
                Reset
              </button>
            </div>
          </div>

          <div style={addButtonContainerStyle} className="col-sm-12 text-right pr-0 mb-4">
              <div 
                style={{ position: 'relative', display: 'inline-block', marginLeft: '15px' }}
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
              >
                <FaInfoCircle 
                  style={{ 
                    color: '#93385D', 
                    fontSize: '20px', 
                    cursor: 'pointer' 
                  }} 
                />
                <div 
                  style={{
                    position: 'absolute',
                    right: '125%',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    backgroundColor: '#333',
                    color: '#fff',
                    padding: '8px 12px',
                    borderRadius: '4px',
                    fontSize: '12px',
                    whiteSpace: 'nowrap',
                    opacity: showTooltip ? 1 : 0,
                    visibility: showTooltip ? 'visible' : 'hidden',
                    transition: 'opacity 0.3s, visibility 0.3s',
                    zIndex: 1000,
                    pointerEvents: 'none'
                  }}
                >
                  This Data is fetched from STN
                  <div style={{
                    position: 'absolute',
                    left: '100%',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    border: '5px solid transparent',
                    borderLeftColor: '#333'
                  }}></div>
                </div>
              </div>
            </div>
            <div className="col-sm-12 p-0 pl-2 mt-6">
              <div className="ag-theme-alpine" style={{ height: 500, width: "100%" }}>
                  <AgGridReact
                    rowData={rowData}
                    columnDefs={columnWithDefs}
                    defaultColDef={defaultColDef}
                    domLayout="normal"
                    sideBar={sideBar}
                    statusBar={statusPanel}
                    pagination={true}
                    paginationPageSize={rowData.length}
                    enableRangeSelection={true}
                    gridOptions={{
                      suppressHorizontalScroll: false
                    }}
                  />
              </div>
          </div>
          <div>

          </div>
        </div>
      </div>
      <div
        className={`stock-status-slider ${isSliderOpen ? "open" : ""} ${sliderCl}`}
        style={{width : "25%"}}
      >
        <div className="slider-header-container d-flex justify-content-between">
          <p className="m-0p">{sliderTitle}</p>
          <p
            className="m-0p"
            style={{ cursor: "pointer" }}
            onClick={onClickingSliderCloseIcon}
          >
            X&nbsp;&nbsp;&nbsp;
          </p>
          
        </div>

      {sliderType === 1 && (
        <form style={{ padding: "20px" }}> 
            <div className="form-group">
              <label htmlFor="plantId" style={{
                fontSize: "0.9rem",
                fontWeight: "bold",
                color: "#333",
                marginBottom: "5px",
                display: "block"
              }}>Plant Id <span style={{color :"red"}}>*</span></label>
              <div id="plantId" >
                <input
                  type="text"
                  className="form-control"
                  id="plant_id"
                  pattern="[a-zA-Z0-9_-]+"
                  name="plant_id"
                  onChange={(e) => setEditFormData({ ...editFormData, plant_id: e.target.value })}
                  value={editFormData.plant_id}
                  placeholder="Enter Plant Id"
                  style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                    fontSize: "0.9rem"
                  }}
                  autoComplete="off"
                  required
                  title="Plant Id can only contain letters, numbers, underscores, and hyphens"
                />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="plantName" style={{
                fontSize: "0.9rem",
                fontWeight: "bold",
                color: "#333",
                marginBottom: "5px",
                display: "block"
              }}>Plant Name <span style={{color :"red"}}>*</span></label>
              <div id="plantName" >
                <input
                  type="text"
                  className="form-control"
                  id="plant_name"
                  name="plant_name"
                  placeholder="Enter Plant Code"
                  onChange={(e) => setEditFormData({ ...editFormData, plant_name: e.target.value })}
                  value={editFormData.plant_name}
                  style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                    fontSize: "0.9rem"
                  }}
                  autoComplete="off"
                />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="plantLocation" style={{
                fontSize: "0.9rem",
                fontWeight: "bold",
                color: "#333",
                marginBottom: "5px",
                display: "block"
              }}>Location<span style={{color :"red"}}>*</span></label>
              <div id="plantLocation" >
                <input
                  type="text"
                  className="form-control"
                  id="location"
                  name="location"
                  placeholder="Enter Plant Code"
                  onChange={(e) => setEditFormData({ ...editFormData, location: e.target.value })}
                  value={editFormData.location}
                  style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                    fontSize: "0.9rem"
                  }}
                  autoComplete="off"
                />
              </div>

            </div>
            <div className="form-group">
              <label htmlFor="plantRegion" style={{
                fontSize: "0.9rem",
                fontWeight: "bold",
                color: "#333",
                marginBottom: "5px",
                display: "block"
              }}>Region <span style={{color :"red"}}>*</span></label>  
              <div id="plantRegion" >
                <input
                  type="text"
                  className="form-control"  
                  id="region"
                  name="region"
                  placeholder="Enter Region"
                  onChange={(e) => setEditFormData({ ...editFormData, region: e.target.value })}
                  value={editFormData.region}
                  style={{
                    width: "100%",  
                    padding: "10px",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                    fontSize: "0.9rem"
                  }}
                  autoComplete="off"
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="PlantRemarks" style={{
                fontSize: "0.9rem",
                fontWeight: "bold",
                color: "#333",
                marginBottom: "5px",
                display: "block"
              }}>Remarks<span style={{color :"red"}}>*</span></label>
              <div id="PlantRemarks" >
                <input
                  type="text"
                  className="form-control"
                  id="remarks"
                  name="remarks"
                  placeholder="Enter Remarks"
                  onChange={(e) => setEditFormData({ ...editFormData, remarks: e.target.value })}
                  value={editFormData.remarks}
                  style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                    fontSize: "0.9rem"
                  }}
                  autoComplete="off"

                />
              </div>
            </div>
            <div style={{
              textAlign: "right",
              marginTop: "10px"
            }}>
                <button
                type="submit"
                id = "sample-download-button"
                // className="btn btn-success"
                onClick={(e) => {
                  e.preventDefault();
                  handleAddSkuProduct();
                }}
              >
                  ADD
              </button>
            </div>
        </form>
      )}

      {sliderType === 2 && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              overflowY: "auto",
              padding: 5,
            }}
          >
            <div style={{ flexGrow: 1, overflowY: "auto", padding: "10px" }}>
              <div className="d-flex justify-content-end mb-10p">
                <button
                  id = "sample-download-button"
                  // className="btn btn-info"
                  onClick={downloadExcelTemplate}
                >
                  {"Download Sample Template"}
                  {/* Download Sample Template */}
                </button>
              </div>
              <input
                type="file"
                accept=".csv,.xlsx,.xls"
                onChange={handleFileChange}
                style={{
                  border: "1px solid lightgrey",
                  width: "100%",
                  padding: "8px",
                  borderRadius: "5px",
                  backgroundColor: "#f9f9f9",
                  color: "#000",
                  fontSize: "13px",
                }}
                value={file}
                id="bulkUploadFile"
              />
              <p
                style={{
                  color: "red",
                  fontSize: "13px",
                  margin: "0px",
                  marginTop: "10px",
                }}
              >
                *Accept .csv & .xlsx files only
              </p>
              <div style={{ textAlign: "right", marginTop: "10px" }}>
                <button
                  className="btn"
                  style={{
                    backgroundColor: "#93385D",
                    color: "#fff",
                    fontSize: "0.8rem",
                  }}
                  onClick={(e)=> {
                    e.preventDefault()
                    setLoadshow("show-m")
                    setOverlayBlock("show-m")
                    onClickingFileSubmit(e)
                  }}
                >
                  {"Submit"}
                </button>
              </div>
             

            </div>
          </div>
      )}
      {sliderType === 3 && (
        <form style={{ padding: "20px" }}          
          onSubmit={(e) => {
              e.preventDefault()
              e.stopPropagation()
              onClickingUpdateSkuData();
          }}>
          <div className="form-group">
            <label htmlFor="plant_id" style={{
              fontSize: "0.9rem",
              fontWeight: "bold",
              color: "#333",
              marginBottom: "5px",
              display: "block"
            }}>Plant Id <span style={{color :"red"}}>*</span></label>
            <input
              type="text"
              className="form-control"
              id="plant_id"
              name="plant_id"
              value={editFormData.plant_id}
              onChange={(e) => setEditFormData({ ...editFormData, plant_id: e.target.value })}
              placeholder="Enter Plant Id"
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                fontSize: "0.9rem",
                backgroundColor: "#f9f9f9",
                cursor: "not-allowed",
              }}
              disabled  // ⬅️ this makes the field read-only
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="plant_name" style={{
              fontSize: "0.9rem",
              fontWeight: "bold",

              color: "#333",
              marginBottom: "5px",
              display: "block"
            }}>Plant Name <span style={{color :"red"}}>*</span></label>
            <input
              type="text"
              className="form-control"
              id="plant_name"
              name="plant_name"
              value={editFormData.plant_name}
              onChange={(e) => setEditFormData({ ...editFormData, plant_name: e.target.value })}
              placeholder="Enter Plant Name"
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                fontSize: "0.9rem"
              }}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="location" style={{
              fontSize: "0.9rem",
              fontWeight: "bold",
              color: "#333",
              marginBottom: "5px",
              display: "block"
            }}>Location<span style={{color :"red"}}>*</span></label>
            <input
              type="text"
              className="form-control"
              id="location"
              name="location"
              value={editFormData.location}
              onChange={(e) => setEditFormData({ ...editFormData, location: e.target.value })}
              placeholder="Enter Location"
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                fontSize: "0.9rem"
              }}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="region" style={{
              fontSize: "0.9rem",
              fontWeight: "bold",
              color: "#333",
              marginBottom: "5px",
              display: "block"
            }}>Region <span style={{color :"red"}}>*</span></label>
            <input
              type="text"
              className="form-control"
              id="region"
              name="region"
              value={editFormData.region}
              onChange={(e) => setEditFormData({ ...editFormData, region: e.target.value })}
              placeholder="Enter Region"
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                fontSize: "0.9rem"
              }}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="remarks" style={{
              fontSize: "0.9rem",
              fontWeight: "bold",
              color: "#333",
              marginBottom: "5px",
              display: "block"
            }}>Remarks<span style={{color :"red"}}>*</span></label>
            <input
              type="text"
              className="form-control"
              id="remarks"
              name="remarks"
              value={editFormData.remarks}
              onChange={(e) => setEditFormData({ ...editFormData, remarks: e.target.value })}
              placeholder="Enter Remarks"
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                fontSize: "0.9rem"
              }}
              required
            />
          </div>
          <div style={addButtonContainerStyle}>
            <button
              type="submit"
              id = "sample-download-button"

              // className="btn btn-success"
              // onClick={(e) => {
              //   e.preventDefault();
              //   onClickingUpdateSkuData();
              // }}
            >
              Update
            </button>
          </div>
        </form>
    )}
      </div>
           {showDeletePopup && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            position: "fixed",
            top: "40%",
            left: "40%",
            zIndex: "1003",
            backgroundColor: "rgba(255, 255, 255, 0.9)",
            padding: "20px",
            borderRadius: "10px",
          }}
        >
          <div className="inventory-delete-popup">
            <p
              style={{
                color: "grey",
                fontSize: "19px",
                textAlign: "center",
                fontWeight: "bold",
                marginBottom: "20px",
              }}
            >
              {`Are you sure you want to delete ${selectedRow ? selectedRow.plant_id : ""}?`}
            </p>
            <div className="d-flex justify-content-center align-items-center">
              <button
                className="btn btn-danger"
                onClick={onClickingPopupDeleteBtn}
              >
               Delete
              </button>
              <button
                className="btn btn-secondary"
                onClick={onClickDeletePopupCancelBtn}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
<div style={{ zIndex: 997 }} className={`overlay-block ${overlayBlock}`}></div>
        <div
          className={"overly-block " + overlyBlock}
          onClick={hideOverlySlideBlock}
        ></div>
    </>
  );
};
const addButtonContainerStyle = { textAlign: "right", marginTop: "10px" };
const addButtonStyle = {
  padding: "5px 20px",
  backgroundColor: "#93385D",
  color: "#fff",
  fontFamily :"sans-serif",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
  fontSize: "0.8rem",
  fontWeight: "bold",
};

export default BatchMaster;